import { useI18n } from '../../i18n'

type EditIconButtonProps = {
   onClick: () => void
   /** Accessible label (defaults to "Edit"). */
   label?: string
}

/**
 * Renders the round, outlined pencil button that opens an edit dialog; shared by the
 * habit cards and the entry lists so they look the same.
 *
 * @param props - The click handler and optional label.
 * @returns The button element.
 */
const EditIconButton = (props: EditIconButtonProps) => {
   const t = useI18n()
   /**
    * Returns the button's accessible label.
    *
    * @returns The label.
    */
   const label = () => props.label ?? t('Edit')

   return (
      <button
         type="button"
         class="habit-icon-button shrink-0 border border-edge text-ink-secondary hover:border-emerald-400 hover:text-emerald-200"
         title={label()}
         aria-label={label()}
         onClick={() => props.onClick()}
      >
         <svg aria-hidden="true" viewBox="0 0 24 24" class="h-5 w-5">
            <path
               d="M4.5 19.5h4L19.5 8.5l-4-4L4.5 15.5v4ZM13.5 6.5l4 4"
               fill="none"
               stroke="currentColor"
               stroke-linecap="round"
               stroke-linejoin="round"
               stroke-width="2"
            />
         </svg>
      </button>
   )
}

export default EditIconButton
